import React, { useContext, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import BodyClassName from "react-body-classname"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

import { ApplicationContext } from 'context'

import Loading from 'components/Loading'
import AlertModal from 'components/AlertModal'
import ConfirmModal from 'components/ConfirmModal'

import navigation from './navigation'

import styles from './styles.module.scss'

const Layout = ({ isHidingNavigation, navigation: incomingNavigation, bodyClassName, children }) => {
  const { contextAlert, contextConfirm, contextLoading, contextError, contextAgency } = useContext(ApplicationContext)
  const [confirm, setConfirm] = contextConfirm
  const [alert, setAlert] = contextAlert
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [agency, setAgency] = contextAgency // eslint-disable-line
  const [error, setError] = contextError // eslint-disable-line
  const [isForcedClosed, setIsForcedClosed] = useState(false)
  const [isViewingFooter, setIsViewingFooter] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  // useEffect(() => {
  //   window.Intercom("boot", {
  //     api_base: "https://api-iam.intercom.io",
  //     app_id: "fwcutcau",
  //     externalId: props.agency?.employee_id,
  //     name: props.agency?.employee_name, // Full name
  //     email: props.agency?.employee.email, // Email address
  //     created_at: "<%= current_user.created_at.to_i %>", // Signup date as a Unix timestamp
  //     type: "AGENCY",
  //     agency_id: props.agency?.id,
  //     agency: props.agency?.companyName,
  //     user_id: props.agency?.employee_id,
  //     user_hash: props.agency?.intercomHmac
  //   })
  // }, [props.agency])

  // Alert Stuff

  const _onAlertClose = () => {
    setAlert({ display: false, title: null, text: null })
  }

  const _confirmBack = () => {
    setConfirm({ type: null, name: null, description: null, meta: null, callback: null })
  }

  const _confirmAction = () => {
    const data = { ...confirm }
    delete data.callback
    confirm.callback(data)
    setConfirm({ type: null, name: null, description: null, meta: null, callback: null })
  }

  // Layout

  let className = ''
  if (bodyClassName) className = bodyClassName
  if (process.env.REACT_APP_BUILD !== 'production') className = `${className} is-development`

  let classes = styles.primaryContainer
  if (agency) {
    if (isForcedClosed) classes += ' ' + styles.primaryContainer__closed
  } else {
    classes += ' ' + styles.primaryContainer__noAccount
  }

  let menuLinks = incomingNavigation || navigation
  if (isHidingNavigation) {
    menuLinks = null
  }

  return (
    <BodyClassName className={className}>
      <div className={classes}>
        {(agency) && (
          <aside>
            <div className={styles.sidebar__top}>
              <header>
                <h1 onClick={() => {
                  setIsForcedClosed(false)
                }}>Simply Bail - Portal</h1>
                <button onClick={() => setIsForcedClosed(v => !v)}><i className="fa-light fa-bars"></i></button>
              </header>
              <nav>
                {(menuLinks?.length > 0) && menuLinks
                  .map((itm, key) => {
                    let classes = ""
                    if (itm.className) classes += itm.className
                    if (location.pathname === itm.path) classes += ' ' + styles.active
                    if (itm.type === 'TITLE') {
                      return <h5 className={`rad ${styles.titleBar}`}>{itm.title}</h5>
                    } else if (itm.sub?.length > 0) {
                      return (
                        <div key={`navigation_primary_${key}`}>
                          <button 
                            className={classes} 
                            onClick={() => navigate(itm.path)}>
                            {itm.icon}
                            <strong>{itm.title}</strong>
                          </button>
                          <div className={styles.sub}>
                            {itm.sub.map((sub, subKey) => {
                              let subClasses = ""
                              if (sub.className) subClasses += sub.className
                              return (
                                <button 
                                  key={`navigation_${key}_${subKey}`} 
                                  className={subClasses} 
                                  onClick={() => navigate(sub.path)}>
                                  {sub.icon}
                                  <strong>{sub.title}</strong>
                                </button>
                              )
                            })}
                          </div>
                        </div>
                      )
                    } else {
                      return (
                        <button 
                          key={`navigation_${key}`} 
                          className={classes} 
                          onClick={() => navigate(itm.path)}>
                          {itm.icon}
                          <strong>{itm.title}</strong>
                        </button>
                      )
                    }
                  })}
              </nav>
              {(agency && !isHidingNavigation) && (
                <nav className={styles.settings}>
                  <button onClick={() => navigate('/settings')}>
                    <FontAwesomeIcon icon={icon({name: 'gear'})} />
                    <strong>Settings</strong>
                  </button>
                </nav>
              )}
            </div>
            {agency && (
              <div className={styles.sidebar__btm}>
                {isViewingFooter && (
                  <div className={styles.sidebar__footer__menu}>
                    {/* <button onClick={() => console.log('Profile')}>My Profile</button> */}
                    <button onClick={() => navigate('/logout')}>Sign Out</button>
                  </div>
                )}
                <footer className={styles.sidebar__footer} onClick={() => setIsViewingFooter(v => !v)}>
                  <div className={styles.sidebar__footer__left}>
                    <span>JH</span>
                    <h4>Jeffey H.</h4>
                  </div>
                  <i className="fa-thin fa-circle-chevron-down"></i>
                </footer>
              </div>
            )}
          </aside>
        )}
        <div className={`main ${styles.main__content}`}>
          {error && (
            <div className={styles.error__container}>
              <div className={styles.error}>
                <div className={styles.error__left}>
                  <p>{error}</p>
                </div>
                <div className={styles.error__right}>
                  <button onClick={() => setError(null)}><i className="fa-solid fa-xmark"></i></button>
                </div>
              </div>
            </div>
          )}
          {children}
        </div>
        <AlertModal title={alert.title} text={alert.text} isOn={alert.display} onClose={_onAlertClose} />
        {confirm.type && (
          <ConfirmModal 
            title={confirm.title}
            text={confirm.description}
            meta={confirm.meta}
            onConfirm={_confirmAction}
            onCancel={_confirmBack}
          />
        )}
        {isLoading && <Loading />}
      </div>
    </BodyClassName>
  )
}

export default Layout
